/** Sub-pixel layout rounding must not make the anchor block look like it is off the header line. */
const REPLAY_TOLERANCE = 1

/**
 * Whether an animated element replays its entrance animation after a device switch in preview.
 *
 * Replaying everything blinked the whole frame (ENG-2004/#23984). The preview keeps the anchor
 * block flush under the fixed header, so:
 * - a block starting below that line sits further down the page — it replays, and reads as the
 *   content arriving;
 * - a block straddling the line (top cut off, bottom still showing) is partially visible — it
 *   replays too, since part of it would otherwise vanish for no reason;
 * - a block flush with the line is the anchor, and a block ending at or above the line is behind
 *   the user — neither replays.
 *
 * `block` holds the viewport-relative top and bottom of the block containing the element. With no
 * block, the element replays, matching the behaviour before this rule existed.
 */
export function shouldReplayOnDeviceChange(args: {
  block: { top: number; bottom: number } | null
  headerHeight: number
}): boolean {
  const { block, headerHeight } = args

  if (!block) {
    return true
  }

  const startsBelowLine = block.top > headerHeight + REPLAY_TOLERANCE
  const straddlesLine = block.top < headerHeight - REPLAY_TOLERANCE && block.bottom > headerHeight + REPLAY_TOLERANCE

  return startsBelowLine || straddlesLine
}
